export const DEFAULT_INTEREST = 0.065;
export const DEFAULT_CREDIT_DURATION_YEARS = 30;
